import React from 'react';
import * as PropTypes from 'prop-types';
import styles from './InfoTable.module.scss';
import Tooltip from 'components/Tooltip';
import cn from 'classnames';

export function InfoTable({ children }) {
  return <div className={styles.InfoTable}>{children}</div>;
}

InfoTable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export function InfoTableTitle({ children }) {
  return <div className={cn([styles.InfoTableRow, styles.InfoTableHeader])}>{children}</div>;
}

InfoTableTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export function InfoTableRow({ title, value, tooltip, className }) {
  return (
    <div className={`${className} ${styles.InfoTableRow} row`}>
      <div className={`${styles.itemName} col-sm-6 col-12`}>{title}</div>
      <div className={`${styles.itemValue} col-sm-6 col-12`}>
        <div className="help-wrap help-wrap__inline">
          <span>{value}</span>
          {tooltip && <Tooltip content={tooltip} isFormClass={true} />}
        </div>
      </div>
    </div>
  );
}

InfoTableRow.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
